module.exports = __webpack_public_path__ + "static/media/golf9.d66d5d7a.jpg";